<!-- eslint-disable vue/multi-word-component-names -->

<script setup>

</script>

<template>
  <main class="w-full h-auto my-1">
    <section class=" h-[1100px] md:h-[700px] relative flex justify-center items-start">
      <div class="w-full h-[200px] sm:h-[400px] ">
        <img class="object-cover w-full h-full" src="../assets/services.webp" alt="">
      </div>
      <div
        class="container mx-auto absolute top-[130px] sm:top-[200px] md:top-[300px] left-1/2 transform -translate-x-1/2 w-11/12 h-auto flex flex-col md:flex-row items-center justify-between">
        <div class="w-full sm:w-2/3 md:w-1/3 h-[300px] md:h-[320px] bg-sky-600 flex flex-col items-center justufy-center">
          <div class="w-11/12 h-2/6 flex items-center justify-center">
            <img class="w-auto h-2/3" src="../assets/ezgif.com-gif-maker.webp" alt="">
          </div>
          <h3 class="w-11/12 h-1/6 flex items-center justify-center text-[18px] font-semibold text-white">subject1</h3>
          <p class="w-11/12 h-3/6 flex items-center justify-center text-[16px] text-white">Providing high quality
            medical accessories with lowest price for Iran, Iraq, Syria, Russia and Central Asia
            market.</p>
        </div>

        <div class="w-full sm:w-2/3 md:w-1/3 h-[300px] md:h-[320px] bg-sky-500 flex flex-col items-center justufy-center">
          <div class="w-11/12 h-2/6 flex items-center justify-center">
            <img class="w-auto h-2/3" src="../assets/ezgif.com-gif-maker.webp" alt="">
          </div>
          <h3 class="w-11/12 h-1/6 flex items-center justify-center text-[18px] font-semibold text-white">subject2</h3>
          <p class="w-11/12 h-3/6 flex items-center justify-center text-[16px] text-white">Our experienced biomedical
            engineer team can give solutions to equip hospitals and operations room with most advanced technologies
            especially in the field of laparoscopy, ENT and neurosurgery.</p>
        </div>

        <div class="w-full sm:w-2/3 md:w-1/3 h-[300px] md:h-[320px] bg-sky-400 flex flex-col items-center justufy-center">
          <div class="w-11/12 h-2/6 flex items-center justify-center">
            <img class="w-auto h-2/3" src="../assets/ezgif.com-gif-maker.webp" alt="">
          </div>
          <h3 class="w-11/12 h-1/6 flex items-center justify-center text-[18px] font-semibold text-white">subject3</h3>
          <p class="w-11/12 h-3/6 flex items-center justify-center text-[16px] text-white">Our experience manufacturing
            team can provide full technology for making production line of medical consumables especially in the field
            of surgical gloves.</p>
        </div>
      </div>
    </section>
  </main>
</template>

<style scoped></style>
